import React, {useState, useEffect} from 'react'

// const styles = makeStyles({
//     partyContainer: ({
//         alignItems: 'center',
//         height: 25,
//         margin: 3,
//         position: 'relative',
//         width: '80%',
//         color: 'black',
//         fontWeight: 'bold',
//         letterSpacing: 1,
//         display: 'flex',
//         position: 'relative',
//         justifyContent: 'space-between',
//         borderBottom: '1px solid black',
//         '& .minus': {
//             position: 'absolute',
//             left: props=>props.small ? -10:-15, 
//             fontWeight: 'bolder'

//         },
//         '& .plus': {
//             position: 'absolute',
//             right: props=>props.small? -10 :  -15,
//             fontWeight: 'bolder'

//         }
//     }),
//     gainsBar: {
//         backgroundColor: props=> props.color,
//         position: "absolute",
//         bottom: 0,
//         right: props=> props.width <= 0 && '50%',
//         left: props=> props.width > 0 && '50%',
//         height: '60%',
//         borderWidth: '1px',
//         borderStyle: 'solid',
//         borderColor: props=>props.color,
//         margin: 0,
//         padding: 0, 
//         transition: `width 300ms ease-in-out`,
//         transitionDelay: '100ms'
//     }
// })

const GainsBar = (props) => {
    const [barWidth, setWidth] = useState(0)  

    useEffect(() => {
        setWidth(props.width)
    }, [props])

    return (
        <div className={'classes.partyContainer items-center relative w-11/12 flex-1 grid grid-cols-12 gap-2'}>
            <div className="">-</div>
            <div className="col-span-10 relative h-full items-center flex justify-center">
                <div 
                    style={{
                        backgroundColor: props.color, 
                        right: props.width < 0 && '50%', 
                        left: props.width > 0 && '50%', 
                        width: `${Math.abs(barWidth)+1}%`, 
                        borderColor: props.color,
                    }} 
                    className={'h-[60%] border-2 absolute'}></div>
            </div>
            <div className="justify-self-end">+</div>
        </div>
    )
}

export default GainsBar